import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import webApiClient from '@tunein/web-api-client';
import {
  CLIENT_API_TIMEOUT,
  CLIENT_API_RETRY_LIMIT,
} from 'src/common/constants/experiments/config';
import getConfigStreamFormats from 'src/common/utils/getConfigStreamFormats';
import config from '../../common/config';
import setGraphQlStatus from '../../common/utils/setGraphQlStatus';

export default function createTuneInApiClient(initialState) {
  const authTokens = pick(initialState.auth.tokenInfo, [
    'accessToken',
    'refreshToken',
  ]);
  const rmConfigs = get(initialState, 'config.autoupdate', {});
  const isMobile = get(initialState, 'app.isMobile');
  const isDesktop = get(initialState, 'app.isDesktop');
  const desktopVersion = get(initialState, 'app.desktopVersion');
  const rtid = get(initialState, 'app.tuneInUserSerial');
  const partnerId = get(initialState, 'app.partnerId');

  const apiConfig = {
    ...config.api,
    partnerId,
    serial: rtid,
    timeout: rmConfigs[CLIENT_API_TIMEOUT],
    retryLimit: rmConfigs[CLIENT_API_RETRY_LIMIT],
    streamFormats: getConfigStreamFormats(
      isMobile,
      isDesktop,
      initialState.app.userAgent,
    ),
  };

  if (desktopVersion) {
    apiConfig.desktopVersion = desktopVersion;
  }

  const client = webApiClient(apiConfig);

  setGraphQlStatus(initialState, client);

  if (!isEmpty(authTokens)) {
    client.setTokens(authTokens);
  }

  return client;
}
